module.exports = __webpack_public_path__ + "img/create_gist_scope.57f5a4f7.png";